import styled from 'styled-components';

import { LogoWithText } from '@components/branding';
import { StepperSimple } from '@components/stepper-simple';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

export const PreboardingPageContainer: React.FC = ({ children }) => {
  return (
    <PageContainer>
      <LogoContainerCenter>
        <LogoWithText />
      </LogoContainerCenter>
      {children}
    </PageContainer>
  );
};

const PageContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '100vh',
});
const LogoContainerCenter = styled.div({
  position: 'absolute',
  top: pxToRem(40),
});

export const ContentContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.space[6],
  width: pxToRem(448),
  zIndex: 1,
});

export const ButtonsContainer = styled.div({
  display: 'flex',
  width: '100%',
  gap: theme.space[4],
  '& > *': {
    width: '100%',
  },
});

export const PreboardingStepper = ({ currentIndex }: { currentIndex: number }) => {
  return <StepperSimple totalSteps={3} activeIndex={currentIndex} />;
};
